
import { defineComponent, PropType } from 'vue'

// types
import { UploadedFileT } from '@/core/types/create_order.types'

// components
import TheButton from '@/common/components/UI/TheButton/index.vue'

export default defineComponent({
    components: {
        TheButton,
    },
    props: {
        isVisible: {
            type: Boolean,
            default: false,
        },
        noDelete: {
            type: Boolean,
            default: false,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        files: {
            type: Array as PropType<UploadedFileT[]>,
            default: () => [],
        },
        title: {
            type: String,
            default: null,
        },
    },
    emits: ['delete'],
    setup(_, { emit }) {
        const deleteFile = (id: number, index: number) => {
            emit('delete', { id, index })
        }

        return {
            deleteFile,
        }
    },
})
